export default {
  table: {
    total: "Total",
    dataCount: "records",
    emptyText: "No data",
    loadingText: "Loading...",
    columns: {
      index: "No.",
      name: "Name",
      canvasName: "Canvas Name",
      createDate: "Create Date",
      updateTime: "Update Time",
      actions: "Actions",
    },
    actions: {
      view: "View",
    },
  },
};
